var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3 13.7V10.3H4L4 13.7H8.3ZM10.3 13.7L20 13.7V10.3L10.3 10.3V13.7ZM8.3 4H5C4.44772 4 4 4.44772 4 5V8.3H8.3V4ZM10.3 4L10.3 8.3L20 8.3V5C20 4.44772 19.5523 4 19 4H10.3ZM8.3 20V15.7H4V19C4 19.5523 4.44772 20 5 20H8.3ZM10.3 20H19C19.5523 20 20 19.5523 20 19V15.7H10.3V20ZM2 19L2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/Leads.acd9be692ec0be61635f21fa9f80caef.svg";
export { ForwardRef as ReactComponent };